import { render, staticRenderFns } from "./ModalPopup.vue?vue&type=template&id=36b5e2dd&scoped=true&"
import script from "./ModalPopup.vue?vue&type=script&lang=js&"
export * from "./ModalPopup.vue?vue&type=script&lang=js&"
import style0 from "./ModalPopup.vue?vue&type=style&index=0&id=36b5e2dd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b5e2dd",
  null
  
)

export default component.exports